import axios from 'axios';

const axiosInstnace = axios.create({
  baseURL: '/',
  timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
  }
});

export default axiosInstnace;
